import React, { FC } from 'react'

import './NewsListItem.scss'
import IconComponent from 'app_components/commons/icons';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { IPost } from 'app_types/campus/postTypes';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { routingService } from 'app_services/routingService';

interface INewsListItemProps {
  post: IPost
}

const DATE_FORMAT = 'DD/MM/YYYY'

const NewsListItem: FC<INewsListItemProps> = ({ post }) => {
  return (
    <Link to={routingService.getPublicPath(`/noticia/${post.slug}`)}>
      <div className="news-list-item--layout">
        <div className='news-list-item--clock-container'>
          <IconComponent svg='Clock' width={24} color={'#0085CA'} />
          <LabelComponent fontWeight={400}>{moment.utc(post.postDate).format(DATE_FORMAT)}</LabelComponent>
        </div>
        <TextComponent elipsis fontWeight="bold">{post.title}</TextComponent>
        <TextComponent elipsis>{post.subtitle}</TextComponent>
      </div>
    </Link>
  )
}

export default NewsListItem
